/* Useful helpers we might use in several components */

import isBoolean from 'lodash/isBoolean';

const TRUTHINESS = {
    'true': true,
    '1': true,
    'yes': true,

    'false': false,
    '0': false,
    'no': false,
    '': false,
    'undefined': false,
    'null': false
};

const defaultScrollDelay = 8000;

function truthy(val, fallback=false) {
    if (isBoolean(val)) return val;

    if (val === undefined) return fallback;

    return TRUTHINESS[String(val).toLowerCase()] || false;
}

// conditionally display a classname if exp is true
function classed(classname, exp) {
    return exp ? classname : '';
}

// https://stackoverflow.com/questions/39538473/using-settimeout-on-promise-chain
function delay(t, v) {
    return new Promise(resolve => {
        setTimeout(resolve.bind(null, v), t);
    });
}

/* prepend MEDIA_HOST to path */
function media(path) {
    return window.MEDIA_HOST + path;
}

/* prepend path to music, plus media path */
function music(filename) {
    return media(`audio/music/${filename}`);
}

/* use mobile or desktop path for video, as needed */
function video(filename) {

    // fix existing paths
    filename = filename.replace(/video\//, '');
    
    if (window.isMobile && window.isMobile.any) {
        return media(`video/mobile/${filename}`);
    } else {
        return media(`video/${filename}`);
    }
}

/* use mobile or desktop path for poster image, as needed */
function poster(filename) {

    if (window.isMobile && window.isMobile.any) {
        return media(`img/poster/mobile/${filename}`);
    } else {
        return media(`img/poster/${filename}`);
    }
}

// play a video/audio element from 0
function play(mediaEl) {
    mediaEl.currentTime = 0;
    setTimeout(() => mediaEl.play(), 10);
}

function isReverse(current, prev) {

    // if we're just arriving, go forward
    if (prev === undefined) {
        return false;
    };

    // if we're comign from the previous slide, go forward
    if (prev[0] < current[0]) {
        return false;
    }

    // if we're backing up from the next slide, reverse
    if (prev[0] > current[0]) {
        return true;
    };

    // next slide has no bullets, and we back up
    if (current[0] === prev[0] && current[1] === prev[1]) {
        return true;
    }

    // check if current or previous bullet is higher
    if (current[0] === prev[0]) {
        return current[1] < prev[1];
    } 

    return false;
}

function pauseMedia(){
    let media = document.querySelectorAll("video, audio");
    for (let index = 0; index < media.length; index++) {
        let media_item = media[index];
        if ( !media_item.paused ) media_item.pause();
    }
}

function triggerIndexVideo(){
    const video = document.querySelector('.chapter-video-playing');

    if (video) video.play().catch(noop);

    const inactive = document.querySelectorAll('.chapter-video-paused');

    for (var i = inactive.length - 1; i >= 0; i--) {
        if ( !inactive[i].paused ) inactive[i].pause();
    }
}

function clearHintTimeout(){
    if ( window.isMobile.any ) return;
    const active_slide = document.querySelector('.bespoke-active');
    if (active_slide.classList.contains('idle')) active_slide.classList.remove('idle');
    if(window.HintTimeout) clearTimeout(window.HintTimeout);
}

function setHintTimeout(milliseconds=defaultScrollDelay){
    if ( window.isMobile.any ) return;
    window.HintTimeout = setTimeout(function(){ 
        const active_slide = document.querySelector('.bespoke-active');
        active_slide.classList.add("idle");
    }, milliseconds);
}

function syncCues(track, display) {
    if (track && display) {
        track.addEventListener('cuechange', event => {
            display.set({ cues: event.target.track.activeCues });
        });
    }
}

// the best function
function noop() {}

export {
    media,
    video,
    poster,
    music,
    truthy,
    classed,
    play,
    isReverse,
    pauseMedia,
    triggerIndexVideo,
    clearHintTimeout,
    setHintTimeout,
    defaultScrollDelay,
    syncCues,
    noop,
}